import { DICT_BASE_URL, DICT_CONFIG, ZHUYING_TONES, ZHUYIN_MAP, TONES, UTONES } from './constants';

export function parse(s) {
  return s.match(/([^AEIOU:aeiou]*)([AEIOUaeiou:]+)([^aeiou:]*)([1-5])/);
}

export const numericPinyin2Zhuyin = (syllable) => {
  return (
    ZHUYIN_MAP[syllable.substring(0, syllable.length - 1).toLowerCase()] +
    ZHUYING_TONES[syllable[syllable.length - 1]] +
    '</span>'
  );
};

const tonify = (vowels, tone) => {
  let html = '';
  let text = '';

  if (vowels === 'ou') {
    html = 'o' + TONES[tone] + 'u';
    text = 'o' + UTONES[tone] + 'u';
  } else {
    let tonified = false;
    for (let i = 0; i < vowels.length; i++) {
      let c = vowels.charAt(i);
      html += c;
      text += c;
      if (c === 'a' || c === 'e') {
        html += TONES[tone];
        text += UTONES[tone];
        tonified = true;
      } else if (i === vowels.length - 1 && !tonified) {
        html += TONES[tone];
        text += UTONES[tone];
        tonified = true;
      }
    }

    html = html.replace(/u:/, '&uuml;');
    text = text.replace(/u:/, '\u00FC');
  }

  return [html, text];
};

export const pinyinAndZhuyin = (syllables, showToneColors, pinyinClass) => {
  let text = '';
  let html = '';
  let zhuyin = '';
  let a = syllables.split(/[\s·]+/);
  for (let i = 0; i < a.length; i++) {
    let syllable = a[i];

    // ',' in pinyin
    if (syllable === ',') {
      html += ' ,';
      text += ' ,';
      continue;
    }

    if (i > 0) {
      html += '&nbsp;';
      text += ' ';
      zhuyin += '&nbsp;';
    }

    if (syllable === 'r5') {
      if (showToneColors) {
        html += '<span class="' + pinyinClass + ' tone5">r</span>';
      } else {
        html += '<span class="' + pinyinClass + '">r</span>';
      }

      text += 'r';
      continue;
    }

    if (syllable === 'xx5') {
      if (showToneColors) {
        html += '<span class="' + pinyinClass + ' tone5">??</span>';
      } else {
        html += '<span class="' + pinyinClass + '">??</span>';
      }

      text += '??';
      continue;
    }

    let m = parse(syllable);
    if (showToneColors) {
      html += '<span class="' + pinyinClass + ' tone' + m[4] + '">';
    } else {
      html += '<span class="' + pinyinClass + '">';
    }

    let t = tonify(m[2], m[4]);
    html += m[1] + t[0] + m[3];
    html += '</span>';
    text += m[1] + t[1] + m[3];

    let zhuyinClass = 'w-zhuyin';
    if (DICT_CONFIG.fontSize === 'small') {
      zhuyinClass += '-small';
    }

    zhuyin +=
      '<span class="tone' +
      m[4] +
      ' ' +
      zhuyinClass +
      '">' +
      numericPinyin2Zhuyin(syllable) +
      '</span>';
  }

  return [html, text, zhuyin];
};

export function findNextTextNode(root, previous) {
  if (root === null) return null;

  const nodeIterator = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, null);
  let node = nodeIterator.nextNode();

  while (node !== previous) {
    node = nodeIterator.nextNode();
    if (node === null) {
      return findNextTextNode(root.parentNode, previous);
    }
  }

  let result = nodeIterator.nextNode();
  if (result !== null) return result;

  return findNextTextNode(root.parentNode, previous);
}

// modifies selEndList as a side-effect
const getTextFromSingleNode = (node, selEndList, maxLength) => {
  if (node.nodeName !== '#text') return '';

  const endIndex = Math.min(maxLength, node.data.length);
  selEndList.push({
    node: node,
    offset: endIndex,
  });

  return node.data.substring(0, endIndex);
};

// modifies selEndList as a side-effect
export const getText = (startNode, offset, selEndList, maxLength) => {
  if (startNode.nodeType !== Node.TEXT_NODE) return '';

  const endIndex = Math.min(startNode.data.length, offset + maxLength);
  let text = startNode.data.substring(offset, endIndex);
  selEndList.push({
    node: startNode,
    offset: endIndex,
  });

  let nextNode = startNode;
  while (
    text.length < maxLength &&
    (nextNode = findNextTextNode(nextNode.parentNode, nextNode)) !== null
  ) {
    text += getTextFromSingleNode(nextNode, selEndList, maxLength - text.length);
  }

  return text;
};

export const getDictFile = (filename) => {
  return `${DICT_BASE_URL}${filename}`;
};

export const loadDictData = async () => {
  const wordDict = fetch(getDictFile('cedict_ts.u8')).then((r) => r.text());

  const wordIndex = fetch(getDictFile('cedict.idx')).then((r) => r.text());

  const grammarKeywords = fetch(getDictFile('grammarKeywordsMin.json')).then((r) => r.json());

  return Promise.all([wordDict, wordIndex, grammarKeywords]);
};
